import { render, staticRenderFns } from "./OrderHistoryModal.vue?vue&type=template&id=4b8b36ec&scoped=true"
import script from "./OrderHistoryModal.vue?vue&type=script&lang=js"
export * from "./OrderHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./OrderHistoryModal.vue?vue&type=style&index=0&id=4b8b36ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b36ec",
  null
  
)

export default component.exports